/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conn_TestingInputs */

const cs_ebr_conn_testing = /** @type {(inputs: Ebr_Conn_TestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testuji…`)
};

const en_ebr_conn_testing = /** @type {(inputs: Ebr_Conn_TestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testing…`)
};

/**
* | output |
* | --- |
* | "Testing…" |
*
* @param {Ebr_Conn_TestingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conn_testing = /** @type {((inputs?: Ebr_Conn_TestingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conn_TestingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conn_testing(inputs)
	return cs_ebr_conn_testing(inputs)
});